<template>
<!--   <md-toolbar md-elevation="0" class="md-transparent">
    <div class="md-toolbar-row"> -->
      
   <!--    <div class="md-toolbar-section-start" style="color: white;">
        <h3 class="md-title" style="color: white;">{{ $route.name }}</h3>
      </div> -->

      <div class="md-toolbar-section-end">
      
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <i class="material-icons">menu</i>
        </md-button>
<!-- 
        <div class="md-collapse">
          <md-list>
            <md-list-item @click="logout">
              <i class="material-icons">logout</i>
              <p class="hidden-lg hidden-md">Logout</p>
            </md-list-item>
          </md-list>
        </div> -->
      </div>
   <!--  </div>
  </md-toolbar> -->
</template>

<script>
import router from "@/routes";
import io from "socket.io-client";
export default {
  data() {
    return {
      socket: null,
      selectedEmployee: null,
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone"
      ]
    };
  },
  methods: {
    logout() {
      this.socket = io("https://agriedge.ca/irrig_all/", {
        query: { user: localStorage.getItem("authToken") }
      });
      this.socket.emit("logout", { id: localStorage.getItem("authToken") });
      localStorage.removeItem("authToken");
      router.push("/login");
      //  router.push('/login')
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    }
  }
};
</script>

<style lang="css"></style>
